module.exports = __webpack_public_path__ + "img/currency-dollar.7fa4d330.svg";